import { render } from "./PhoneFaultNotTurnOn.vue?vue&type=template&id=54e3601d"
import script from "./PhoneFaultNotTurnOn.vue?vue&type=script&lang=js"
export * from "./PhoneFaultNotTurnOn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__